// actions
export const ALLOCATE_CREDIT = "ALLOCATE_CREDIT";
export const ADD_EVENT = "ADD_EVENT";
export const APPLY_AGENDA_FILTERS = "APPLY_AGENDA_FILTERS";
export const APPLY_FILTERS = "APPLY_FILTERS";
export const ARCHIVE_EVENT = "ARCHIVE_EVENT";
export const BLOCK_TIMESLOT_EDITION = "BLOCK_TIMESLOT_EDITION";
export const CANCEL_PLAN_EVENT = "CANCEL_PLAN_EVENT";
export const CLEAR_AGENDA_FILTER = "CLEAR_AGENDA_FILTER";
export const CLEAR_PLAN_EVENT = "CLEAR_PLAN_EVENT";
export const CLEAR_TO_BE_PLANNED_EVENT = "CLEAR_TO_BE_PLANNED_EVENT";
export const CONFIRM_SELECTED_EVENT = "CONFIRM_SELECTED_EVENT";
export const CREATE_EVENT = "CREATE_EVENT";
export const CREATE_EVENT_TIME_SLOT = "CREATE_EVENT_TIME_SLOT";
export const DEFINE_SIMULTANEOUS_TIME_SLOT = "DEFINE_SIMULTANEOUS_TIME_SLOT";
export const DEFINE_TIME_SLOT_ID = "DEFINE_TIME_SLOT_ID";
export const DO_EVENT = "DO_EVENT";
export const FETCH_CALENDAR_EVENTS = "FETCH_CALENDAR_EVENTS";
export const FETCH_CREDIT = "FETCH_CREDIT";
export const FETCH_REST_WORK_TIME = "FETCH_REST_WORK_TIME";
export const FETCH_TO_BE_PLANNED_EVENTS = "FETCH_TO_BE_PLANNED_EVENTS";
export const LOAD_EVENT_TYPE = "LOAD_EVENT_TYPE";
export const LOAD_EVENT_TYPE_GROUP = "LOAD_EVENT_TYPE_GROUP";
export const PLAN_EVENT = "PLAN_EVENT";
export const REMOVE_AGENDA_EVENT_FILTER = "REMOVE_AGENDA_EVENT_FILTER";
export const REMOVE_EVENT_FILTER = "REMOVE_EVENT_FILTER";
export const REMOVE_SIMULTANEOUS_TIME_SLOT = "REMOVE_SIMULTANEOUS_TIME_SLOT";
export const SCHEDULE_MULTI_TIMESLOT = "SCHEDULE_MULTI_TIMESLOT";
export const SET_TO_BE_PLANNED_NEW_ORDER = "SET_TO_BE_PLANNED_NEW_ORDER";
export const UNDO_SELECTED_EVENT = "UNDO_SELECTED_EVENT";
export const UPDATE_EVENT = "UPDATE_EVENT";
export const UPDATE_EVENT_PICKED_DURATION = "UPDATE_EVENT_PICKED_DURATION";
export const UPDATE_EVENT_COMMENT = "UPDATE_EVENT_COMMENT";
export const UPDATE_EVENT_DESCRIPTION = "UPDATE_EVENT_DESCRIPTION";
export const UPDATE_EVENT_QUANTITY = "UPDATE_EVENT_QUANTITY";
export const UPDATE_EVENT_DEADLINE = "UPDATE_EVENT_DEADLINE";
export const UPDATE_EVENT_CONFIRMED_RS = "UPDATE_EVENT_CONFIRMED_RS";
export const UPDATE_TIME_SLOT = "UPDATE_TIME_SLOT";
export const UNPLAN_EVENT = "UNPLAN_EVENT";
export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_REQUEST_SSO = "AUTH_REQUEST_SSO";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_INIT = "AUTH_INIT";
export const UPDATE_USER = "UPDATE_USER";
export const AUTH_REFRESH = "AUTH_REFRESH";
export const AUTH_REMOVE_REFRESH = "AUTH_REMOVE_REFRESH";
export const LOAD_NOTIFICATION = "LOAD_NOTIFICATION";
export const READ_NOTIFICATION = "READ_NOTIFICATION";
export const SET_DOMICILE = "SET_DOMICILE";
export const SET_LOADING = "SET_LOADING";
export const SET_IMPERSONATE = "SET_IMPERSONATE";
export const UNSET_IMPERSONATE = "UNSET_IMPERSONATE";
export const SET_CALENDAR_OWNER = "SET_CALENDAR_OWNER";
export const SET_EVENT_SEARCH = "SET_EVENT_SEARCH";
export const LOAD_HOLIDAYS = "LOAD_HOLIDAYS";
export const LOAD_CALENDAR_OWNERS = "LOAD_CALENDAR_OWNERS";
export const LOAD_CALENDAR_OWNER = "LOAD_CALENDAR_OWNER";
export const SET_SUPERVISION_FILTERS_ENABLED =
  "SET_SUPERVISION_FILTERS_ENABLED";
export const FETCH_DEPARTMENTS = "FETCH_DEPARTMENTS";
export const FETCH_BUSINESS_GROUPS = "FETCH_BUSINESS_GROUPS";
export const FETCH_EVENT_RULES = "FETCH_EVENT_RULES";
export const REMOVE_EVENT_RULE = "REMOVE_EVENT_RULE";
export const SET_CALENDAR_DATE = "SET_CALENDAR_DATE";
export const SET_SELECTED_CALENDAR_EVENT = "SET_SELECTED_CALENDAR_EVENT";
export const UNSET_SELECTED_CALENDAR_EVENT = "UNSET_SELECTED_CALENDAR_EVENT";
export const SCHEDULE_CALENDAR_EVENT = "SCHEDULE_CALENDAR_EVENT";
export const FIX_SELECTED_CALENDAR_EVENT = "FIX_SELECTED_CALENDAR_EVENT";
export const SET_IMPERSONATION_REDIRECT_PATH =
  "SET_IMPERSONATION_REDIRECT_PATH";
